<h2 mat-dialog-title mat-dialog-draggable-title>{{'title.view_procedure' | translate}}
    <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="onNoClick()">
        <span aria-hidden="true">&times;</span>
    </button>
</h2>

<mat-divider></mat-divider>

<form #f="ngForm" (ngSubmit)="!f.form.valid? accordion.openAll() : 'true' && f.form.valid && onCreateProcedure()"
    appFocusFirstElement name="form" [appCheckProcedureName]="['procedureName']"
    [appCheckProcedureNamePrefix]="[procedureNamePrefix]">

    <mat-dialog-content>

        <mat-accordion #accordion="matAccordion" [multi]="true">
            <mat-expansion-panel class="mt-3" expanded=true>
                <mat-expansion-panel-header class="pt-2">
                    <mat-panel-title class="mat-panel-title justify-content-between">
                        <span>{{'title.procedure_info' | translate}}</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row">
                    <!-- Nhập tên quy trình -->
                    <div class="col-sm-12">
                        <div>
                            {{'placeholder.procedure_name' | translate}}:
                            <span><strong>{{procedure.procedureName}} </strong></span>
                        </div>
                        <!-- </mat-form-field> -->
                    </div>
                </div>
                <br>
                <div class="row">

                    <!-- Loai quy trinh -->
                    <div class="col-sm-12">
                        <div>
                            {{'placeholder.procedure_type' | translate}}:
                            <span><strong>{{ procedureTypeString }}</strong></span>
                        </div>
                    </div>
                </div>
                <br>
                <div class="row">
                    <!-- Mo ta quy trinh -->
                    <div class="col-sm-12">
                        <div>
                            {{'placeholder.procedure_desc' | translate}}:
                            <span><strong>{{ procedure.description }}</strong></span>
                        </div>
                    </div>

                </div>
            </mat-expansion-panel>

            <div *ngIf="this.isFullProcedure != null">

                <mat-expansion-panel expanded="true" class="mat-elevation-z0" *ngIf="this.isFullProcedure">
                    <mat-expansion-panel-header>
                        <mat-panel-title class="mat-panel-title">
                            {{ "form.contracting_parties" | translate }}
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <!-- Nz-table set luồng chủ thể -->
                    <!-- <form nz-form> -->
                    <!-- <span class="float-right" *ngIf="this.valueSelect == '0' ">
                {{'enterprise_contract.panel_document.table_parties.guide_checkbox' | translate}}</span> -->
                    <nz-table #partyRowTable nzBordered [nzData]="RECORD_PARTY_SIGN" [nzShowPagination]="false"
                        [nzFrontPagination]="false"
                        class="ant-table-no-placeholder-border-bottom no-ant-table-placeholder">
                        <thead>
                            <tr>
                                <th class="text-center" nzWidth="55px">
                                    {{
                                    "enterprise_contract.panel_document.table_parties.header.order"
                                    | translate
                                    }}
                                </th>
                                <th class="text-center">
                                    {{
                                    "enterprise_contract.panel_document.table_parties.header.party_name"
                                    | translate
                                    }}
                                </th>
                                <th class="text-center" nzWidth="30%">
                                    {{
                                    "enterprise_contract.panel_document.table_parties.header.email"
                                    | translate
                                    }}
                                </th>
                                <th class="text-center" nzWidth="18%" colspan="2" *ngIf="!isNotAttestedUser">
                                    {{
                                    "enterprise_contract.panel_document.table_parties.header.phone"
                                    | translate
                                    }}
                                </th>
                              <th class="text-center" nzWidth="18%" *ngIf="isNotAttestedUser">
                                {{
                                "enterprise_contract.panel_document.table_parties.header.phone"
                                  | translate
                                }}
                              </th>
<!--                                <th nzWidth="25px" *ngIf="!isNotAttestedUser">-->
<!--                                    {{-->
<!--                                    "enterprise_contract.panel_document.table_parties.header.sign_no_login"-->
<!--                                    | translate-->
<!--                                    }}-->
<!--                                </th>-->
                                <th nzWidth="25px" *ngIf="this.valueSelect == '0'">
                                    {{
                                    "enterprise_contract.panel_document.table_parties.header.insert_infor"
                                    | translate
                                    }}
                                </th>
                                <th nzWidth="25px"></th>
                            </tr>
                        </thead>
                        <tbody *ngFor="let data of partyRowTable.data;let i = index;">
                            <tr class="editable-row">
                                <!-- TT -->
                                <td class="text-center" rowspan="2" *ngIf="!data.isCreatedSide">
                                    {{data.order}}
                                </td>
                              <td class="text-center" *ngIf="data.isCreatedSide">
                                {{data.order}}
                              </td>
                                <!-- Tên -->
                                <td class="word-break-line">
                                    {{ data.name }}
                                </td>
                                <!-- Email -->
                                <td class="word-break-line">
                                    <div>{{ data.email }}</div>
                                </td>

                                <!-- Phone -->
                                <td class="word-break-line" colspan="2" *ngIf="!isNotAttestedUser">
                                    <div>{{ data.phone }}</div>
                                </td>
                              <td class="word-break-line"  *ngIf="isNotAttestedUser">
                                <div>{{ data.phone }}</div>
                              </td>
<!--                                <td class="text-center" *ngIf="!isNotAttestedUser">-->
<!--                                    <label nz-checkbox [(ngModel)]="data.isSignNoLogin"-->
<!--                                        [ngModelOptions]="{ standalone: true }" *ngIf="!data.isCreatedSide"-->
<!--                                        nzDisabled></label>-->
<!--                                </td>-->
                              <td class="text-center"  *ngIf="data.isCreatedSide">
                                <div class="d-flex">
                                  <a (click)="isShowUserSignTable = !isShowUserSignTable"
                                     *ngIf="data.isCreatedSide" style="transition: 0.3s; margin-left: 7px; display: flex; align-items: center;"
                                     [ngStyle]="{'transform': !isShowUserSignTable ? 'rotate(0deg)' : 'rotate(180deg)'}">
                                    <i class="fa fa-angle-down" aria-hidden="true" nzIcon
                                       style="font-size: 17px; "
                                       matTooltip="{{ (isShowUserSignTable ? 'tooltips.hidden' : 'tooltips.show') | translate }}"></i>
                                  </a>
                                </div>
                              </td>
                                <td class="text-center" rowspan="2" *ngIf="!data.isCreatedSide">
                                    <div class="d-flex">
                                        <a (click)="isShowUserSignTable = !isShowUserSignTable"
                                            *ngIf="data.isCreatedSide" style="transition: 0.3s; margin-left: 7px; display: flex; align-items: center;"
                                            [ngStyle]="{'transform': !isShowUserSignTable ? 'rotate(0deg)' : 'rotate(180deg)'}">
                                            <i class="fa fa-angle-down" aria-hidden="true" nzIcon
                                                style="font-size: 17px; "
                                                matTooltip="{{ (isShowUserSignTable ? 'tooltips.hidden' : 'tooltips.show') | translate }}"></i>
                                        </a>
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="!data.isCreatedSide">
                              <td colspan="4" *ngIf="!isNotAttestedUser">
                                <label nz-checkbox [(ngModel)]="data.isSignNoLogin" class="checkbox-disabled" style="color:rgba(0, 0, 0, 0.87) !important; "
                                       [ngModelOptions]="{ standalone: true }" *ngIf="!data.isCreatedSide && !isNotAttestedUser"
                                       >{{'enterprise_contract.panel_document.table_parties.header.SNL' | translate}}</label>
                                <label nz-checkbox [(ngModel)]="data.signConfig.showImage" class="checkbox-disabled" style="color:rgba(0, 0, 0, 0.87) !important; "
                                       [ngModelOptions]="{ standalone: true }" *ngIf="!data.isCreatedSide && data.customerType !== 10000"
                                        > {{'enterprise_contract.panel_document.table_parties.header.DSIS' | translate}}</label>
                              </td>
                              <td colspan="3" *ngIf="isNotAttestedUser && data.customerType!==10000">
                                <label nz-checkbox [(ngModel)]="data.isSignNoLogin" class="checkbox-disabled" style="color:rgba(0, 0, 0, 0.87) !important; "
                                       [ngModelOptions]="{ standalone: true }" *ngIf="!data.isCreatedSide && !isNotAttestedUser"
                                >{{'enterprise_contract.panel_document.table_parties.header.SNL' | translate}}</label>
                                <label nz-checkbox [(ngModel)]="data.signConfig.showImage" class="checkbox-disabled" style="color:rgba(0, 0, 0, 0.87) !important; "
                                       [ngModelOptions]="{ standalone: true }" *ngIf="!data.isCreatedSide && data.customerType !== 10000"
                                > {{'enterprise_contract.panel_document.table_parties.header.DSIS' | translate}}</label>
                              </td>
                            </tr>
                            <tr *ngIf="showTableMembers && data.isCreatedSide && isShowUserSignTable">
                                <td
                                  [attr.rowspan]="(isValidNoUserExist || isValidExistingSigning) ?
                                  RECORD_USER_PERFORM_SIGN.length + 6
                                  : RECORD_USER_PERFORM_SIGN.length + 5"
                                  >
                                </td>
                                <td [attr.colspan]="setColspan(6)" style="padding: 0 !important;">
                                    <div class="mat-panel-title mat-panel-title_custom font-color-blue">
                                        {{ "form.order_of_approval_signing_contract_unit" | translate }}
                                    </div>
                                  <!-- Nz-table set luồng ký / duyệt-->

                                  <!-- End Nz-table set luồng ký / duyệt-->
                                </td>
                              </tr>

                              <tr *ngIf="showTableMembers && data.isCreatedSide && isShowUserSignTable"
                              style="background: #fafafa;" class="text-primary"
                              >
                              <td class="text-center" [attr.colspan]="setColspan(5)" style="padding: 0 !important;">
                                <div class="d-flex">
                                  <div style="width: 40px;padding: 6px 8px; border-right: 1px solid #d9d9d9;">
                                    {{
                                    "enterprise_contract.panel_document.table_users.header.order"
                                    | translate
                                    }}
                                  </div>
                                  <div class="d-flex justify-content-center" style="width: 100%; align-items: center;">
                                    {{
                                    "enterprise_contract.panel_document.table_users.header.name"
                                    | translate
                                    }}
                                  </div>
                                </div>
                              </td>
                              <td></td>
                              </tr>
                              <!-- Người dùng phê duyệt hợp đồng -->
                              <tr *ngIf="showTableMembers && data.isCreatedSide && isShowUserSignTable">
                                <td [attr.colspan]="setColspan(5)" style="padding: 0 !important;">
                                    <div class="d-flex align-items-center">
                                      <div class="w-100 mat-panel-title_custom font-color-blue" style="padding-left: 10px; margin-right: 3rem;">
                                        {{ "form.contract_approver" | translate}} &nbsp;
                                      </div>
                                      <div class="text-center mat-panel-title_custom font-color-blue"
                                           style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; line-height: 20px;">
                                        {{"enterprise_contract.panel_document.table_parties.header.sig_cts" | translate}}
                                      </div>
                                      <div class="text-center mat-panel-title_custom font-color-blue"
                                        style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; line-height: 20px;">
                                        {{"enterprise_contract.panel_document.table_parties.header.display_signature" | translate}}
                                      </div>
                                    </div>
                                    </td>
                              <td></td>
                              </tr>

                              <!-- Danh sách người dùng phê đuuyệt hợp đồng -->
                              <tr *ngFor="let user of RECORD_USER_PERFORM_SIGN; let i = index"
                                [hidden]="!(showTableMembers && data.isCreatedSide && isShowUserSignTable) || !(user.role !== '1' && data.isCreatedSide)">
                                <td class="text-center" [attr.colspan]="setColspan(5)" style="padding: 0 !important;">
                                    <div class="d-flex">
                                      <div style="width: 50px; max-width: 50px; padding: 15px 20px; border-right: 1px solid #d9d9d9;">
                                        {{ user.order }} </div>
                                          <div class="d-flex" style="width: 100%; align-items: center;  padding: 0 8px">
                                            <div class="editable-cell" *ngIf="user.userId != null">
                                              <div *ngIf="user.departmentName" class="row-icon department"><span
                                                  class="material-icons">apartment</span>{{ user.departmentName }}</div>
                                              <div class="row-icon"><span class="material-icons" *ngIf="!user.departmentName">person</span>
                                                {{user.name}} <span *ngIf="user.email">- {{user.email}}</span> <span *ngIf="user.userPosition"> - {{user.userPosition}}</span></div>
                                            </div>
                                          </div>
                                          <div class="d-flex justify-content-center" style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; align-items: center;">
                                              <label nz-checkbox [(ngModel)]="user.isSignDigitalCertificate" class="checkbox-disabled"

                                                     [ngModelOptions]="{ standalone: true }">
                                              </label>
                                            </div>
                                            <div class="d-flex justify-content-center" style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; align-items: center;">
                                              <ng-container *ngIf="user && user.isSignDigitalCertificate">
                                                <label nz-checkbox [ngModel]="user?.signConfig?.showImage"  class="checkbox-disabled"
                                                  [ngModelOptions]="{ standalone: true }">
                                                </label>
                                              </ng-container>
                                            </div>
                                    </div>
                                </td>
                                <td class="text-center">
                                </td>
                              </tr>

                              <!-- Tìm kiếm người dùng phê duyệt hợp đồng -->

                              <!-- Người dùng Ký duyệt hợp đồng -->
                              <tr *ngIf="showTableMembers && data.isCreatedSide && isShowUserSignTable">
                                <td [attr.colspan]="setColspan(6)" style="padding: 0 !important;">
                                    <div class="mat-panel-title_custom font-color-blue" style="padding-left: 10px">
                                      {{ "form.user_signs_and_approves_the_contract" | translate}}
                                    </div>
                                </td>
                              </tr>

                              <!-- Danh sách người dùng Ký đuuyệt hợp đồng -->
                              <tr *ngFor="let user of RECORD_USER_PERFORM_SIGN; let i = index"
                                [hidden]="!(showTableMembers && data.isCreatedSide && isShowUserSignTable) || !(user.role === '1' && data.isCreatedSide)">
                                <td class="text-center" [attr.colspan]="setColspan(5)" style="padding: 0 !important;">
                                    <div class="d-flex">
                                      <div style="width: 50px; max-width: 50px; padding: 15px 8px; border-right: 1px solid #d9d9d9;">
                                        1
                                      </div>
                                      <div class="d-flex" style="width: 100%; align-items: center;  padding: 0 8px">
                                        <div class="editable-cell" *ngIf="user.userId != null">
                                          <div *ngIf="user.departmentName" class="row-icon department"><span
                                              class="material-icons">apartment</span>{{ user.departmentName }}</div>
                                          <div class="row-icon"><span class="material-icons" *ngIf="!user.departmentName">person</span>
                                            {{user.name}} <span *ngIf="user.email">- {{user.email}}</span> <span *ngIf="user.userPosition"> - {{user.userPosition}}</span></div>
                                        </div>
                                      </div>
                                    </div>
                                </td>
                                <td class="text-center">
                                </td>
                              </tr>

                              <!-- Tìm kiếm người dùng Ký duyệt hợp đồng -->
            </tbody>
            </nz-table>

            <!-- End of Nz-table set chu the-->
            </mat-expansion-panel>

            <hr />

            <!-- Nz-table set luồng ký / duyệt-->
            <mat-expansion-panel expanded="true" class="mat-elevation-z0"
                *ngIf="showTableMembers && !this.isFullProcedure">
                <mat-expansion-panel-header>
                    <mat-panel-title class="mat-panel-title font-color-blue">
                        {{ "form.order_of_approval_signing_contract_unit" | translate }}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <!-- <form nz-form> -->
                <nz-table #editRowTable nzBordered [nzData]="RECORD_USER_PERFORM_SIGN" [nzShowPagination]="false"
                    [nzFrontPagination]="false" class="ant-table-no-placeholder-border-bottom">
                    <thead>
                        <tr>
                            <th class="text-center" nzWidth="50px">
                                {{
                                "enterprise_contract.panel_document.table_users.header.order"
                                | translate
                                }}
                            </th>
                            <th class="text-center" nzWidth="100%">
                                {{
                                "enterprise_contract.panel_document.table_users.header.name"
                                | translate
                                }}
                            </th>
                        </tr>
                    </thead>
                    <tbody *ngIf="isShowUserApproveTable">
                        <!-- Người dùng phê duyệt hợp đồng -->
                        <tr>
                            <td [attr.colspan]="setColspan(3)" style="padding: 0 !important;">
                                <div class="d-flex align-items-center">
                                  <div class="w-100 mat-panel-title_custom font-color-blue" style="padding-left: 10px; margin-right: 2rem;">
                                    {{ "form.contract_approver" | translate}} &nbsp;
                                  </div>
                                  <div class="text-center mat-panel-title_custom font-color-blue"
                                       style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; line-height: 20px;">
                                    {{"enterprise_contract.panel_document.table_parties.header.sig_cts" | translate}}
                                  </div>
                                  <div class="text-center mat-panel-title_custom font-color-blue"
                                    style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; line-height: 20px;">
                                    {{"enterprise_contract.panel_document.table_parties.header.display_signature" | translate}}
                                  </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tbody *ngFor="let data of editRowTable.data; let i = index">
                        <tr class="editable-row" *ngIf="data.role !== '1'">
                            <td class="text-center" class="text-center" [attr.colspan]="setColspan(3)" style="padding: 0 !important;">
                                <div class="d-flex">
                                    <div style="width: 50px; max-width: 50px; padding: 15px 8px; border-right: 1px solid #d9d9d9;">
                                        {{ data.order }} </div>
                                            <div class="d-flex" style="width: 100%; align-items: center;  padding: 0 8px">
                                                <div class="editable-cell" *ngIf="data.userId != null">
                                                    <div *ngIf="data.departmentName" class="row-icon department"><span
                                                            class="material-icons">apartment</span>{{ data.departmentName }}
                                                    </div>
                                                    <div class="row-icon word-break-line text-left"><span class="material-icons"
                                                            *ngIf="!data.departmentName">person</span>
                                                        {{data.name}} <span *ngIf="data.email">- {{data.email}}</span> <span *ngIf="data.userPosition"> - {{data.userPosition}}</span></div>
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-center" style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; align-items: center;">
                                                <label nz-checkbox [(ngModel)]="data.isSignDigitalCertificate"
                                                       class="checkbox-disabled"
                                                       [ngModelOptions]="{ standalone: true }">
                                                </label>
                                              </div>
                                              <div class="d-flex justify-content-center" style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; align-items: center;">
                                                <ng-container *ngIf="data && data.isSignDigitalCertificate">
                                                  <label nz-checkbox [ngModel]="data?.signConfig?.showImage" class="checkbox-disabled"
                                                    [ngModelOptions]="{ standalone: true }">
                                                  </label>
                                                </ng-container>
                                              </div>
                                    </div>
                            </td>
                        </tr>
                    </tbody>

                    <tbody>
                        <!-- Người dùng ký duyệt hợp đồng -->
                        <tr>
                            <td colspan="3">
                                <div style="padding-left: 10px; color: #4e73df; font-style: italic;">
                                    {{ "form.user_signs_and_approves_the_contract" | translate}} &nbsp;
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tbody *ngFor="let data of editRowTable.data; let i = index">
                        <tr class="editable-row" *ngIf="data.role === '1'">
                            <td class="text-center" colspan="3" style="padding: 0 !important;">
                                <div class="d-flex">
                                    <div style="width: 50px; max-width: 50px; padding: 15px 8px; border-right: 1px solid #d9d9d9;">
                                        1
                                    </div>
                                    <div class="d-flex" style="width: 100%; align-items: center;  padding: 0 8px">
                                        <div class="editable-cell" *ngIf="data.userId != null">
                                            <div *ngIf="data.departmentName" class="row-icon department"><span
                                                    class="material-icons">apartment</span>{{ data.departmentName }}</div>
                                            <div class="row-icon word-break-line text-left"><span class="material-icons"
                                                    *ngIf="!data.departmentName">person</span>
                                                {{data.name}} <span *ngIf="data.email">- {{data.email}}</span> <span *ngIf="data.userPosition"> - {{data.userPosition}}</span></div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>

                </nz-table>
                <mat-error class="font-weight-bold" *ngIf="isValidNoUserExist || isValidExistingSigning"
                    style="padding-top: 0.5rem">
                    {{ "validation.error_user_no_set_up" | translate }}
                </mat-error>
                <!-- </form> -->
            </mat-expansion-panel>
            </div>

              <div class="pl-4 tree-features">
        <div class="font-weight-bold mt-2" style="color: #000000DE;">
          {{'user_group.user_allow_use_process' | translate}}
        </div>
        <!-- <div style="width: 50% !important; margin-bottom: -1.25rem;"
          class="form-search-tree position-relative">
          <mat-form-field class="mat-full-width">
            <div class="position-absolute" style="top: 9px; left: -22px; cursor: pointer;">
              <mat-icon (click)="searchTree()" class="mr-0" style="font-weight: 900;">search</mat-icon>
            </div>
            <input type="text" #focusInput matInput [formControl]="treeFormControl"
              (keyup.enter)="searchTree()" (focusout)="searchTree()"
              [placeholder]="'user_group.search_tree' | translate" autocomplete="off">
          </mat-form-field>
        </div>

        <ng-container *ngIf="isSearchDataEmpty;else displayTree">
          <p class="text-center mt-2">{{'messages.data_not_found' | translate}}</p>
        </ng-container> -->

        <nz-tree nzBlockNode nzCheckable nzMultiple [nzData]="featuresTree"
          [nzExpandedKeys]="defaultExpandedKeys" [nzBeforeDrop]="beforeDrop"
          (nzCheckBoxChange)="onSelectNode($event)" [nzCheckedKeys]="defaultCheckedKeys"
          (nzExpandChange)="expandParentNode($event)" [nzTreeTemplate]="nzTreeTemplate"></nz-tree>

        <ng-template #nzTreeTemplate let-node>
          <span class="w-100" style="max-height: 500px; overflow-y: auto; overflow-x: hidden;">
            <!-- COMPANY -->
            <ng-container
              *ngIf="node.origin.type === 'COMPANY' || (node.origin.type === 'BRANCH' && enterpriseType === 'BRANCH')">
              <span *ngIf="node.origin.isActive">
                <svg style="display: inline-block; margin-top: -5px;" width="16" height="16"
                  viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.5 15.5H0.5V8.5H1.5" stroke="#001737" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M5.5 10.5H7.5" stroke="#001737" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M5.5 12.5H7.5" stroke="#001737" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M5.5 8.5H7.5" stroke="#001737" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M8.5 3.5V1L15.5 3.5V15.5H3.5V5.5H9.5V15.333" stroke="#001737"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M11.5 12.5V4.5" stroke="#001737" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M13.5 12.5V5.5" stroke="#001737" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </span>
              <span *ngIf="!node.origin.isActive">
                <svg style="display: inline-block; margin-top: -5px;" width="16" height="16"
                  viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.5 15.5H0.5V8.5H1.5" stroke="#919191" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M5.5 10.5H7.5" stroke="#919191" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M5.5 12.5H7.5" stroke="#919191" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M5.5 8.5H7.5" stroke="#919191" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M8.5 3.5V1L15.5 3.5V15.5H3.5V5.5H9.5V15.333" stroke="#919191"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M11.5 12.5V4.5" stroke="#919191" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M13.5 12.5V5.5" stroke="#919191" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </span>
            </ng-container>
            <!-- BRANCH -->
            <ng-container *ngIf="node.origin.type === 'BRANCH' && enterpriseType === 'COMPANY'">
              <span *ngIf="node.origin.isActive">
                <svg style="display: inline-block; margin-top: -5px;" width="16" height="16"
                  viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_2415_1244)">
                    <path d="M14.5 3.5L8 0.5L1.5 3.5" stroke="#001737" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M3.5 2.577V6.5" stroke="#001737" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M12.5 2.577V6.5" stroke="#001737" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M6.5 15.5V11.5H9.5V15.5H15.5V8.5H0.5V15.5H6.5Z" stroke="#001737"
                      stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M6.5 4.5V5.5" stroke="#001737" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M9.5 4.5V5.5" stroke="#001737" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M3.5 11.5V12.5" stroke="#001737" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M12.5 11.5V12.5" stroke="#001737" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </g>
                  <defs>
                    <clipPath id="clip0_2415_1244">
                      <rect width="16" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              <span *ngIf="!node.origin.isActive">
                <svg style="display: inline-block; margin-top: -5px;" width="16" height="16"
                  viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_2415_1244)">
                    <path d="M14.5 3.5L8 0.5L1.5 3.5" stroke="#919191" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M3.5 2.577V6.5" stroke="#919191" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M12.5 2.577V6.5" stroke="#919191" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M6.5 15.5V11.5H9.5V15.5H15.5V8.5H0.5V15.5H6.5Z" stroke="#919191"
                      stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M6.5 4.5V5.5" stroke="#919191" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M9.5 4.5V5.5" stroke="#919191" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M3.5 11.5V12.5" stroke="#919191" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M12.5 11.5V12.5" stroke="#919191" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </g>
                  <defs>
                    <clipPath id="clip0_2415_1244">
                      <rect width="16" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
            </ng-container>
            <!-- NODE_BETWEEN AND DEPARTMENT -->
            <ng-container
              *ngIf="node.origin.type === 'NODE_BETWEEN_BRANCH' || node.origin.type === 'NODE_BETWEEN_USER' || node.origin.type === 'DEPARTMENT'">
              <span *ngIf="node.origin.isActive">
                <svg style="display: inline-block; margin-top: -5px;" width="16" height="16"
                viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_2415_1105)">
                  <path d="M3.5 7.5V0.5H12.5V5.5" stroke="#001737" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M6.5 9.5H0.5V15.5H6.5V9.5Z" stroke="#001737" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M15.5 7.5H9.5V15.5H15.5V7.5Z" stroke="#001737" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M2.5 12.5H4.5" stroke="#001737" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M11.5 10.5H13.5" stroke="#001737" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M11.5 12.5H13.5" stroke="#001737" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M6.5 15.5H9.5" stroke="#001737" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M6.5 3.5H9.5" stroke="#001737" stroke-linecap="round" stroke-linejoin="round" />
                </g>
                <defs>
                  <clipPath id="clip0_2415_1105">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              </span>
              <span *ngIf="!node.origin.isActive">
                <svg style="display: inline-block; margin-top: -5px;" width="16" height="16"
                viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_2415_1105)">
                  <path d="M3.5 7.5V0.5H12.5V5.5" stroke="#919191" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M6.5 9.5H0.5V15.5H6.5V9.5Z" stroke="#919191" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M15.5 7.5H9.5V15.5H15.5V7.5Z" stroke="#919191" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M2.5 12.5H4.5" stroke="#919191" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M11.5 10.5H13.5" stroke="#919191" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M11.5 12.5H13.5" stroke="#919191" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M6.5 15.5H9.5" stroke="#919191" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M6.5 3.5H9.5" stroke="#919191" stroke-linecap="round" stroke-linejoin="round" />
                </g>
                <defs>
                  <clipPath id="clip0_2415_1105">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              </span>
            </ng-container>
            <!-- USER -->
            <ng-container *ngIf="node.origin.type === 'USER'">
              <span *ngIf="node.origin.isActive">
                <svg style="display: inline-block; margin-top: -5px;" width="16" height="16"
                  viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M14.5 12.976C14.5002 12.8151 14.4616 12.6566 14.3874 12.5138C14.3132 12.3711 14.2057 12.2483 14.074 12.156C12.2699 10.9877 10.1474 10.409 8 10.5C5.85262 10.409 3.73005 10.9877 1.926 12.156C1.79427 12.2483 1.68677 12.3711 1.61261 12.5138C1.53844 12.6566 1.49982 12.8151 1.5 12.976V15.5H14.5V12.976Z"
                    stroke="#001737" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M8 7.5C9.933 7.5 11.5 5.933 11.5 4C11.5 2.067 9.933 0.5 8 0.5C6.067 0.5 4.5 2.067 4.5 4C4.5 5.933 6.067 7.5 8 7.5Z"
                    stroke="#001737" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </span>
              <span *ngIf="!node.origin.isActive">
                <svg style="display: inline-block; margin-top: -5px;" width="16" height="16"
                  viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M14.5 12.976C14.5002 12.8151 14.4616 12.6566 14.3874 12.5138C14.3132 12.3711 14.2057 12.2483 14.074 12.156C12.2699 10.9877 10.1474 10.409 8 10.5C5.85262 10.409 3.73005 10.9877 1.926 12.156C1.79427 12.2483 1.68677 12.3711 1.61261 12.5138C1.53844 12.6566 1.49982 12.8151 1.5 12.976V15.5H14.5V12.976Z"
                    stroke="#919191" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M8 7.5C9.933 7.5 11.5 5.933 11.5 4C11.5 2.067 9.933 0.5 8 0.5C6.067 0.5 4.5 2.067 4.5 4C4.5 5.933 6.067 7.5 8 7.5Z"
                    stroke="#919191" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </span>
            </ng-container>
            <span matTooltip="{{ node.title }}"
              [ngClass]="node.origin.isActive ? 'color-text-tree-active font-weight-bold' : 'color-text-tree-inactive font-italic font-weight-normal'"
              class="position-absolute d-inline-block text-truncate {{node.origin.type === 'TYPE_VIRTUAL' ? 'hide-class' : ''}}"
              style="margin-left: 10px; width: 85%;">{{ node.title }}</span>
          </span>
        </ng-template>
      </div>
      <span style="display: inline-block; color: #333333;" class="pl-2 mt-4 mb-2">
        <span>{{'user_group.note_tree' | translate}}</span>
        <span
          style="color: #919191 !important; font-weight: normal; font-style: italic; padding: 0 5px;">"{{'user_group.branch_department_user'
          | translate}}"</span>
        <span>- {{'user_group.inactive' | translate}}</span>
      </span>

        </mat-accordion>
    </mat-dialog-content>

    <mat-dialog-actions align="center">
        <button mat-stroked-button color="primary" class="mr-3" (click)="onNoClick()" type="button">
            <mat-icon class="mr-0">cancel</mat-icon>
            {{'button.close' | translate}}
        </button>
    </mat-dialog-actions>

    <ng-template #contentEmptyTable let-name> </ng-template>

</form>
